(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/mobile-card.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/mobile-card.js');
'use strict';

const _svs$ui$ReactCard = svs.ui.ReactCard,
  CardBody = _svs$ui$ReactCard.CardBody,
  CardExpandableBody = _svs$ui$ReactCard.CardExpandableBody;
const _svs$myProfile$react$ = svs.myProfile.react.pages.myInformation.myInformation.components,
  WhiteCardHeader = _svs$myProfile$react$.WhiteCardHeader,
  PdCard = _svs$myProfile$react$.PdCard;
const _svs$myProfile$react$2 = svs.myProfile.react.pages.myInformation.myInformation.mobile,
  MobileConfirm = _svs$myProfile$react$2.MobileConfirm,
  MobileFooter = _svs$myProfile$react$2.MobileFooter,
  MobileRemove = _svs$myProfile$react$2.MobileRemove,
  MobileSave = _svs$myProfile$react$2.MobileSave,
  MobileText = _svs$myProfile$react$2.MobileText;

const MobileCard = _ref => {
  let _ref$isFocused = _ref.isFocused,
    isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused;
  const dispatch = ReactRedux.useDispatch();
  const _ref2 = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences) || {},
    cellPhoneStatus = _ref2.cellPhoneStatus,
    cellphone = _ref2.cellphone;
  const setForceSaveMobile = svs.myProfile.react.store.pdPreferences.actions.setForceSaveMobile;
  const isForceSaveMobile = ReactRedux.useSelector(state => state.playerPreferences.isForceSaveMobile) || false;
  const mobileVerified = cellPhoneStatus === '2';
  const mobileExists = Boolean(cellphone);
  const mobileRef = React.useRef(null);
  React.useEffect(() => {
    if (isFocused && mobileRef) {
      mobileRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isFocused]);
  const onChange = () => {
    dispatch(setForceSaveMobile(false));
  };
  return React.createElement("div", {
    className: "margin-v-1"
  }, React.createElement("div", {
    className: svs.core.detect.breakpoint.greaterThan('sm') ? 'scroll-margin-card' : 'scroll-margin-card-mobile',
    ref: mobileRef
  }, React.createElement(PdCard, {
    isFocused: isFocused,
    onChange: onChange
  }, React.createElement(WhiteCardHeader, {
    className: "mobile-number-header"
  }, "Mobilnummer"), React.createElement(CardBody, {
    className: "f-left pd-card-body"
  }, React.createElement(MobileText, null)), React.createElement(CardExpandableBody, {
    className: "f-left pd-card-body"
  }, mobileVerified || !mobileExists || isForceSaveMobile ? React.createElement(MobileSave, null) : React.createElement(MobileConfirm, null), mobileExists && React.createElement(MobileRemove, null), (!mobileExists || mobileVerified || isForceSaveMobile) && React.createElement(MobileFooter, null)))));
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileCard = MobileCard;

 })(window);